import React from "react";
import { Breadcrumb, Card, Collapse, Divider, Table, Modal } from "antd";
import { InputNumber, Radio, Rate, Slider, Switch, message, Upload } from "antd";
import { AutoComplete, Button, Cascader, Checkbox, Col, Form, Icon, Input, Row, Select, Tooltip, formLayout } from "antd";


// Switch script start
function onChange(checked) {
  console.log(`switch to ${checked}`);
}
// Switch script start

// search-script
const Search = Input.Search;
// search-script-end

const FormItem = Form.Item;
const Option = Select.Option;
const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;

// import "./basic.less";

const Panel = Collapse.Panel;


// const text = `
//   A dog is a type of domesticated animal.
//   Known for its loyalty and faithfulness,
//   it can be found as a welcome guest in many households across the world.
// `;
const callback = (key) => {
  console.log(key);
};

// const Basic = () => {

// };
{/*
  const data = [{
  key: '1',
  name: 'John Brown',
  age: 32,
  address: 'New York No. 1 Lake Park',
}, {
  key: '2',
  name: 'Jim Green',
  age: 42,
  address: 'London No. 1 Lake Park',
}, {
  key: '3',
  name: 'Joe Black',
  age: 32,
  address: 'Sidney No. 1 Lake Park',
}, {
  key: '4',
  name: 'Jim Red',
  age: 32,
  address: 'London No. 2 Lake Park',
}];
*/}

{/*const columns = [
  {
    title: 'Id',
    dataIndex: 'id',
    key: 'id',
    // render: text => <span className="gx-link">{text}</span>,
  },
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Logo',
    dataIndex: 'logo',
    key: 'logo',
  },
  {
    title: 'Email Address',
    dataIndex: 'emailAddress',
    key: 'emailAddress',
  },
  {
    title: 'Primary Number',
    dataIndex: 'primaryNumber',
    key: 'primaryNumber',
  },
  {
    title: 'Secondary Number',
    dataIndex: 'secondaryNumber',
    key: 'secondaryNumber',
  },
  {
    title: 'Change Password',
    dataIndex: 'changePassword',
    key: 'changePassword',
  },
  {
    title: 'Trusted',
    dataIndex: 'trusted',
    key: 'trusted',
  },
  {
    title: 'Date',
    dataIndex: 'date',
    key: 'date',
  },
  {
    title: 'Approve',
    dataIndex: 'approve',
    key: 'approve',
  },
  {
    title: 'Suspend',
    dataIndex: 'suspend',
    key: 'suspend',
  },
  {
    title: 'Edit',
    dataIndex: 'edit',
    key: 'edit',
  }

];
*/}

const data = [
  {
    key: '1',
    id: '401',
    name: 'Umer',
    logo: <img src={require("../../../src/assets/images/logo-exp.jpg")} />,
    emailAddress: 'example@.com',
    primaryNumber: '+92123456789',
    secondaryNumber: '',
    date: '2020-01-20',
    status: 'Active',
    action: <div className="action-btn">
    <a href="" title="Change Password"><i className="icon icon-forgot-password"></i></a>
    <a href="" title="Suspend"><i className="icon icon-close-circle"></i></a>
    <a href="" title="Edit"><i className="fa fa-pencil"></i></a>
    <a href="" title="Delete"><i className="icon icon-trash"></i></a>
   </div>,
  },
  {
    key: '2',
    id: '402',
    name: 'Umer Khan',
    logo: 'N/A',
    emailAddress: 'example@.com',
    primaryNumber: '+92123456789',
    secondaryNumber: '',
    date: '2020-01-20',
    status: 'Active',
    action: <div className="action-btn">
    <a href="" title="Change Password"><i className="icon icon-forgot-password"></i></a>
    <a href="" title="Suspend"><i className="icon icon-close-circle"></i></a>
    <a href="" title="Edit"><i className="fa fa-pencil"></i></a>
    <a href="" title="Delete"><i className="icon icon-trash"></i></a>
   </div>,
  },
  {
    key: '3',
    id: '403',
    name: 'Umer',
    logo: 'N/A',
    emailAddress: 'example@.com',
    primaryNumber: '+92123456789',
    secondaryNumber: '',
    date: '2020-01-20',
    status: 'Active',
    action: <div className="action-btn">
    <a href="" title="Change Password"><i className="icon icon-forgot-password"></i></a>
    <a href="" title="Suspend"><i className="icon icon-close-circle"></i></a>
    <a href="" title="Edit"><i className="fa fa-pencil"></i></a>
    <a href="" title="Delete"><i className="icon icon-trash"></i></a>
   </div>,
  },
  {
    key: '4',
    id: '404',
    name: 'Umer Khan',
    logo: <img src={require("../../../src/assets/images/logo-exp.jpg")} />,
    emailAddress: 'example@.com',
    primaryNumber: '+92123456789',
    secondaryNumber: '',
    date: '2020-01-20',
    status: 'InActive',
    action: <div className="action-btn">
    <a href="" title="Change Password"><i className="icon icon-forgot-password"></i></a>
    <a href="" title="Suspend"><i className="icon icon-close-circle"></i></a>
    <a href="" title="Edit"><i className="fa fa-pencil"></i></a>
    <a href="" title="Delete"><i className="icon icon-trash"></i></a>
   </div>,

  }

];
// handleSubmit = (e) => {
//   e.preventDefault();
//   this.props.form.validateFields((err, values) => {
//     if (!err) {
//       console.log('Received values of form: ', values);
//     }
//   });
// };



//   upload-script start
const props = {
  name: 'file',
  action: '//jsonplaceholder.typicode.com/posts/',
  headers: {
    authorization: 'authorization-text',
  },
  onChange(info) {
    if (info.file.status !== 'uploading') {
      console.log(info.file, info.fileList);
    }
    if (info.file.status === 'done') {
      message.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === 'error') {
      message.error(`${info.file.name} file upload failed.`);
    }
  },
};
//   upload-script end

class dashboard extends React.Component {
  // form-scripts start
  handleFormLayoutChange = (e) => {
    this.setState({ formLayout: e.target.value });
  }

  constructor() {
    super();
    this.state = {
      formLayout: 'horizontal',
      visible: false,
      addItem: false,
      addOption: false
    };
  }
  // form-scripts end

  // Modal-scripts start
  showModal = () => {
    this.setState({
      visible: true,
    });
  };
  handleOk = (e) => {
    console.log(e);
    this.setState({
      visible: false,
    });
  };
  addItem = (e) => {
    this.setState({
      addItem: !this.state.addItem,
    });
  };
  addOption = (e) => {
    this.setState({
      addOption: !this.state.addOption,
    });
  };
  handleCancel = (e) => {
    console.log(e);
    this.setState({
      visible: false,
    });
  };
  // Modal-scripts end

     // Sort-Table-Scripts-Start

  state = {
    filteredInfo: null,
    sortedInfo: null,
  };
  handleChange = (pagination, filters, sorter) => {
    console.log('Various parameters', pagination, filters, sorter);
    this.setState({
      filteredInfo: filters,
      sortedInfo: sorter,
    });
  };
 
// sort-table-scripts-End

  render() {
    //   const {getFieldDecorator} = this.props.form;
    // const formItemLayout = {
    //   labelCol: {xs: 24, sm: 6},
    //   wrapperCol: {xs: 24, sm: 14},
    // };
    // form-scripts start
    const { formLayout } = this.state;
    const formItemLayout = formLayout === 'horizontal' ? {
      labelCol: { xs: 24, sm: 6 },
      wrapperCol: { xs: 24, sm: 16 },
    } : null;
    const buttonItemLayout = formLayout === 'horizontal' ? {
      wrapperCol: { xs: 24, sm: { span: 14, offset: 6 } },
    } : null;
    // form-scripts end

    // MULTIPLE-scripts start
    const children = [];
    for (let i = 1; i < 10; i++) {
      children.push(<Option key={i.toString(36) + i}>{'test'}</Option>);
    }
    function handleChange(value) {
      console.log(`selected ${value}`);
    }
    // MULTIPLE-scripts End

    // Sort-Table-Scripts-Start
    let {sortedInfo, filteredInfo} = this.state;
    sortedInfo = sortedInfo || {};
    filteredInfo = filteredInfo || {};
    const columns = [
      {
        title: '',
        dataIndex: 'action',
        key: 'action',
      },
      {
      title: 'Id',
      dataIndex: 'id',
      key: 'id',
      sorter: (a, b) => a.id.length - b.id.length,
      sortOrder: sortedInfo.columnKey === 'id' && sortedInfo.order,
    }, 
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      sorter: (a, b) => a.name - b.age,
      sortOrder: sortedInfo.columnKey === 'name' && sortedInfo.order,
    },
    , 
    {
      title: 'Logo',
      dataIndex: 'logo',
      key: 'logo',
      sorter: (a, b) => a.logo.length - b.logo.length,
      sortOrder: sortedInfo.columnKey === 'logo' && sortedInfo.order,
    }, 
    {
      title: 'Email Address',
      dataIndex: 'emailAddress',
      key: 'emailAddress',
      sorter: (a, b) => a.emailAddress.length - b.emailAddress.length,
      sortOrder: sortedInfo.columnKey === 'emailAddress' && sortedInfo.order,
    }
    , 
    {
      title: 'Primary Number',
      dataIndex: 'primaryNumber',
      key: 'primaryNumber',
      sorter: (a, b) => a.primaryNumber.length - b.primaryNumber.length,
      sortOrder: sortedInfo.columnKey === 'primaryNumber' && sortedInfo.order,
    }
    , 
    {
      title: 'Secondary Number',
      dataIndex: 'secondaryNumber',
      key: 'secondaryNumber',
      sorter: (a, b) => a.secondaryNumber.length - b.secondaryNumber.length,
      sortOrder: sortedInfo.columnKey === 'secondaryNumber' && sortedInfo.order,
    }
    , 
    {
      title: 'Date',
      dataIndex: 'date',
      key: 'date',
      sorter: (a, b) => a.date.length - b.date.length,
      sortOrder: sortedInfo.columnKey === 'date' && sortedInfo.order,
    }
    , 
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      sorter: (a, b) => a.status.length - b.status.length,
      sortOrder: sortedInfo.columnKey === 'status' && sortedInfo.order,
    }
    
    
  ];
// sort-table-scripts-End

    return (

      <div className="menu-editor-box card-pad-new menu-cate-list users-main-page">
        <div className="ant-row margin-btm-20 d-None">
          <div className="ant-col ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 ant-col-xl-24">
            <div className="Breadcrumb-inner-box menu-ed">
              <Breadcrumb>
                <Breadcrumb.Item>Menu</Breadcrumb.Item>
                <Breadcrumb.Item>Thai House Wok - Folkungagatan</Breadcrumb.Item>
                <Breadcrumb.Item><span className="gx-link">View on Delivery Pizza.com</span></Breadcrumb.Item>
              </Breadcrumb>
              <div className="icon-more"><i className="icon icon-ellipse-h"></i></div>
            </div>
          </div>
        </div>
        <div className="payout-report-box">
          <Card className="gx-card breadcrumb-box" title="">
          <div className="ant-row hd-title">
          <div className="ant-col-md-12">
          <h1>Dashboard</h1>
          <h1 className="Phase-text">Phase 2</h1>
          </div>
          <div className="ant-col-md-12 rite-btn d-none">
          <Button type="primary" className="color-white"> Create</Button>
          </div>
          </div>
            
            <div className="collaps-main d-none">
              <div className="ant-row">
                <div className="search-box ant-col-md-12">
                  <Search
                    placeholder="search"
                    onSearch={value => console.log(value)}
                    style={{ width: 200 }}
                  />
                  {/*<div className="check-box-fill">
                    <ul>
                      <li><Checkbox onChange={onChange}>Delivery</Checkbox></li>
                      <li><Checkbox onChange={onChange}>Takeaway</Checkbox></li>
                    </ul>
    </div>*/}

                </div>
                <div className="ant-col-md-12">
                  <div className="orders-item top-section filter-box ">
                  <div className="drop-filter-cover d-none">
                      <i className="fa fa-filter filter-icon"></i>
                        <Select className="select-box" defaultValue="Select" onChange={handleChange}>
                          <Option value="Select"> Enabled</Option>
                          <Option value="Select-1">Disabled</Option>
                        </Select>
                  </div>
                    {/*<Button type="primary" className="color-white" onClick={() => { this.props.history.push("") }}> Create</Button>*/}
                  </div>
                </div>
              </div>

              <div className="ant-row">

                <div className="ant-col gx-order-sm-1 ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 ant-col-xl-24">
                  <Table className="gx-table-responsive payout-report menu-cate-lisi-table" columns={columns} dataSource={data} onChange={this.handleChange}/>
                </div>
                
              </div>

            </div>
          </Card>

        </div>

        <div className="ant-row">
          <div className="ant-col ant-col-xs-24 ant-col-sm-24 ant-col-md-10 ant-col-lg-10 ant-col-xl-8 d-None">
            <Card className="gx-card-widget">
              <div className="add-categories-lft-box">
                <div className="disp-inline">
                  <h2 className="title-inner">Categories</h2>
                  <span className="add-catgroey-btn"><a href="#" onClick={this.showModal}><i className="icon icon-add"></i> Add category</a></span>
                </div>
                <ul className="add-catgroe-ul">
                  <li>Thailändska grytor med kokosmjölk <span>(5)</span></li>
                  <li>Nudlar <span>(3)</span></li>
                  <li>Soppor <span>(4)</span></li>
                  <li>Wok <span>(8)</span></li>
                  <li>Sallader <span>(2)</span></li>
                  <li>Vegetariska rätter <span>(2)</span></li>
                  <li>Från grillen <span>(1)</span></li>
                </ul>

              </div>
            </Card>
          </div>
          <div className="ant-col ant-col-xs-24 ant-col-sm-24 ant-col-md-14 ant-col-lg-14 ant-col-xl-16 d-None">
            <Card className="gx-card-widget">
              <div className="collapse-rite-box">
                <div className="disp-inline">
                  <h2 className="title-inner">Items</h2>
                  <span className="add-catgroey-btn"><a href="#" onClick={this.addOption}><i className="icon icon-add"></i> Add option</a></span>
                </div>

                <Collapse defaultActiveKey={['1']} onChange={callback}>
                  <Panel header="1. Geang Keowan" key="1">
                    <p>
                      <div className="multi-dropdown-box">
                        <Select
                          mode="multiple"
                          style={{ width: '100%' }}
                          placeholder="Please select"
                          defaultValue={['Thailändska grytor med', 'Thailändska grytor med-2']}
                          onChange={handleChange}
                        >
                          {children}
                        </Select>

                      </div>
                      <div className="disp-inline">
                        <h2 className="title-inner">Item Details</h2>
                        <span className="add-catgroey-btn"><a href="#" onClick={this.addItem}>Edit</a></span>
                      </div>
                      <Table className="gx-table-responsive item-table-box tabil-box" columns={columns} dataSource={data} />

                    </p>

                  </Panel>
                  <Panel header="2. Geang Keowan" key="2">
                    <p>
                      <div className="multi-dropdown-box">

                      </div>
                      <div className="disp-inline">
                        <h2 className="title-inner">Item Details</h2>
                        <span className="add-catgroey-btn"><a href="#" onClick={this.showModal}>Edit</a></span>
                      </div>
                      <Table className="gx-table-responsive item-table-box tabil-box" columns={columns} dataSource={data} />

                    </p>
                  </Panel>

                </Collapse>

              </div>
            </Card>

          </div>
        </div>


        {/* <Button type="primary" onClick={this.showModal}>Open</Button> */}
        {/* modal-edit */}
        <Modal
          title="Add Category"
          visible={this.state.addItem}
          onOk={this.addItem}
          onCancel={this.addItem}
        >
          <div className="item-detail-edit-box">
            {/* <p>Some contents...</p> */}
            <Form layout={formLayout}>

              <FormItem
                label="Category Name"
                {...formItemLayout}
              >
                <Input placeholder="" />
              </FormItem>
              {/* <FormItem
                                label="Price"
                                {...formItemLayout}
                            >
                                <Input placeholder=""/>
                           </FormItem>*/}
              <FormItem
                label="Image"
                {...formItemLayout}
              >
                <Upload {...props}>
                  <Button className="btn-upload-cust">
                    <Icon type="upload" /> Upload
                                </Button>
                </Upload>
                {/* <Input placeholder=""/> */}
              </FormItem>
              {/* <FormItem
                                label="Alcohol %"
                                {...formItemLayout}
                            >
                                <Input placeholder=""/>
                            </FormItem>*/}
              {/* <FormItem
                                label="POS ID"
                                {...formItemLayout}
                            >
                                <Input placeholder=""/>
                            </FormItem>*/}
              {/* <FormItem
                                label="Field B"
                                {...formItemLayout}
                            >
                                <Input placeholder="input placeholder"/>
                            </FormItem> */}
              {/* <FormItem {...buttonItemLayout}>
                                <Button type="primary">Submit</Button>
                            </FormItem> */}
            </Form>

          </div>

        </Modal>{/* modal-edit-end */}

        {/* modal-edit */}
        <Modal
          title="Add Category"
          visible={this.state.visible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
        >
          <div className="item-detail-edit-box">
            {/* <p>Some contents...</p> */}
            <Form layout={formLayout}>
              <FormItem
                label="Category name"
                {...formItemLayout}
              >
                <Input placeholder="" />
              </FormItem>

            </Form>

          </div>

        </Modal>
        {/* modal-add-option */}

        <Modal
          title="Add a new option"
          visible={this.state.addOption}
          onOk={this.addOption}
          onCancel={this.addOption}
        >
          <div className="item-detail-edit-box">
            <p>Option Details</p>
            <Form layout={formLayout}>
              <FormItem
                label="Optin type"
                {...formItemLayout}
              >
                {/* <Input placeholder=""/> */}
              </FormItem>
              <FormItem
                label="Name"
                {...formItemLayout}
              >
                <Input placeholder="" />
              </FormItem>

            </Form>

          </div>

        </Modal>


      </div>
    );
  }
}
export default dashboard;